module.exports = __webpack_public_path__ + "static/media/good_score.ec046815.svg";